import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=345dfa4e&scoped=true"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"
import style0 from "./Member.vue?vue&type=style&index=0&id=345dfa4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345dfa4e",
  null
  
)

export default component.exports